import React from "react"
import Dialog from "@material-ui/core/Dialog"
import DialogTitle from "@material-ui/core/DialogTitle"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogActions from "@material-ui/core/DialogActions"
import Button from "@material-ui/core/Button"

import PropTypes from "prop-types"

const UserConfirmDialog = ({ isDialogOpen, onConfirm, onClose, title, body, textOk, textCancel }) => (
  <Dialog
    style={{ direction: "rtl" }}
    open={isDialogOpen}
    onClose={onClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description">
        {body}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>
        {textCancel}
      </Button>
      <Button onClick={onConfirm} color="primary">
        {textOk}
      </Button>
    </DialogActions>
  </Dialog>
)

UserConfirmDialog.propTypes = {
  isDialogOpen: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  textCancel: PropTypes.string.isRequired,
  textOk: PropTypes.string.isRequired,
}

export default UserConfirmDialog
